import i18n from 'src/i18n'
import { useRef } from 'react'
import clsx from 'clsx'
import { extensions } from 'src/pages/CommunityDetails/Posts/tiptap/utils/extensionsTiptapEditor'
import { TiptapMethods, TiptapEditor } from 'src/pages/CommunityDetails/Posts/tiptap'
import { HandleOnChangePostModalEditorContent } from 'src/pages/CommunityDetails/PostModalPublication/components/postModalContent/postModalContent.types'
import {
  CustomInput,
  InputCounter
} from 'src/pages/CommunityDetails/PostModalPublication/components/postModalContent/postModalContent.styles'
import { MAX_CHARACTERS } from 'src/pages/CommunityDetails/PostModalPublication/components/postModalContent/postModalContent.constants'
import { useMentionUtils } from 'src/components/postCommentInput/hooks'
import { EditPostModalContentProps } from './editPostModalContent.types'

const EditPostModalContent = ({
  setTitle,
  description,
  setDescription,
  mentions,
  isFullScreen = false,
  postType,
  title = ''
}: EditPostModalContentProps) => {
  const inputRefEditor = useRef<TiptapMethods>(null)

  const { convertMentionToHTML } = useMentionUtils()

  const handleParseMentions = () =>
    convertMentionToHTML({
      text: description,
      htmlTag: 'span',
      mentions: mentions?.map((mention) => ({
        tag: mention?.tag,
        failed: Boolean(mention?.failed),
        failureReason: mention?.failureReason,
        ucode: mention?.metadata?.ucode,
        name: mention?.metadata?.name
      }))
    })

  const handleTitle = (e: React.FormEvent<HTMLInputElement>) =>
    setTitle(e.currentTarget?.value as string)

  const classNameTipTap = clsx('_text-gray-500 _text-2 _mb-0 _border-0 _w-full _overflow-y-scroll')

  const handleOnChange = ({ description }: HandleOnChangePostModalEditorContent) => {
    setDescription(description)
  }

  return (
    <>
      <div className="_d-flex _position-relative _mb-3">
        <InputCounter
          data-test="input-counter"
          className="_h-full _text-1 _text-gray-500 _position-absolute _d-flex _flex-row _align-items-center _justify-content-start"
        >
          <span>{title?.length || 0}</span>
          <span>/</span>
          <span>{MAX_CHARACTERS}</span>
        </InputCounter>

        <CustomInput
          name="input-title"
          className="_pr-9 _text-5 _font-weight-bold _w-full _bg-transparent _border-0 _text-gray-900 _px-0"
          type="text"
          placeholder={i18n.t('modals.publish_post.input_title')}
          aria-label={i18n.t('modals.publish_post.input_title')}
          onChange={handleTitle}
          value={title}
          maxLength={MAX_CHARACTERS}
          autoComplete="off"
          autoFocus
        />
      </div>

      <TiptapEditor
        isEdit
        postType={postType}
        ref={inputRefEditor}
        content={handleParseMentions()}
        extensions={extensions}
        className={classNameTipTap}
        isFullScreen={isFullScreen}
        isOpenUpload={false}
        isFileUploaded={false}
        placeholder={i18n.t('modals.publish_post.placeholder_description_textarea')}
        onChange={handleOnChange}
      />
    </>
  )
}

export default EditPostModalContent
